import { createSelector } from 'reselect';
import { ReduxStore } from '../interfaces/store';
import { WonAuctions } from '../interfaces/store/WonAuctions';

export const wonAuctions = createSelector<ReduxStore, WonAuctions, WonAuctions>(
  root => root.wonAuctions,
  root => root
);
